import React, { useMemo } from "react";

import { BlankContentForList } from "@/components/features/_components";

import { Button } from "@/components/ui/button/button";
import { Table, TableBody } from "@/components/ui/table/table";

import { SearchResultTableTBody } from "./t-body";
import { SearchResultTableTHead } from "./t-head";

import type * as SharedModel from "../../model";

type Props = {
	// @todo 命名が腑に落ちていない
	aboutChildren?: React.ReactNode;
	// 行データ
	rows: Array<SharedModel.Type.ViewData.SearchResultTableRowData>;
};

export const SearchResultTable = ({ aboutChildren, rows }: Props) => {
	/**
	 * 予約リストを表示できるか
	 */
	const canShowReservationList = useMemo(() => rows.length > 0, [rows]);

	return (
		<>
			{canShowReservationList ? (
				<div className="space-y-8">
					{aboutChildren}
					<div className="space-y-4 overflow-y-scroll shadow-sm">
						<div className="text-sm">
							「リピーター」のラベルがつきました！詳細は
							<Button type="button" className="h-0 px-2" variant="link">
								<a
									href="https://www.notion.so/chillnn/286fffe15c5780ac8332f629c3cc3179"
									className="gap-x-0 break-all text-link-400"
								>
									こちら
								</a>
							</Button>
							。
						</div>
						<Table id="search-result-table" className="w-full min-w-[max-content]">
							{/* ヘッダー */}
							<SearchResultTableTHead />

							{/* 行 */}
							<TableBody className="relative">
								<>
									{rows.map((row, index) => (
										<SearchResultTableTBody key={index} row={row} />
									))}
								</>
							</TableBody>
						</Table>
					</div>
				</div>
			) : (
				<BlankContentForList content={`予約がありません。\n条件を変更して検索してください。`} />
			)}
		</>
	);
};
